export default __webpack_public_path__ + "static/media/b_349x250.1e12bea6.png";